import LeadCard from "./LeadCard"

export default  LeadCard;
